import script from "./NewsWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsWidget.vue?vue&type=script&setup=true&lang=js"

import "./NewsWidget.vue?vue&type=style&index=0&id=35e9ac7d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35e9ac7d"]])

export default __exports__